import styled from 'styled-components';
import Header from './Header';

export default function MainLayout({ children }: { children?: React.ReactNode }) {
  return (
    <MainLayoutBase>
      <Header />
      <PageContent>{children}</PageContent>
    </MainLayoutBase>
  );
}

const MainLayoutBase = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const PageContent = styled.div`
  width: 100%;
  flex: 1;
  overflow: hidden;
  margin-top: 56px;
`;
